import React from 'react'
import { LockKeyhole } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function SlotsReadOnlyTable({ slots = [] }) {
  const { t, i18n } = useTranslation()
  const english = i18n?.language?.startsWith('en') ?? false
  if (!slots.length) return null
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5">
      <h2 className="text-base font-semibold">{t('playbook.cards.slots')}</h2>
      <p className="mt-1 text-xs text-slate-500">{t('playbook.readOnlySlots')}</p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full min-w-[500px] text-left text-sm">
          <thead className="font-mono text-[11px] text-slate-500"><tr><th className="p-2">{t('playbook.fields.displayName')}</th><th className="p-2">{t('playbook.fields.kind')}</th><th className="p-2">{t('playbook.fields.required')}</th><th className="p-2">{t('playbook.fields.askIf')}</th><th /></tr></thead>
          <tbody>{slots.map((slot) => <tr key={slot.key} className="border-t border-slate-100"><td className="p-2 font-medium">{(english ? slot.label_en : slot.label_vi) ?? slot.label ?? slot.key}</td><td className="p-2">{slot.kind ?? '—'}</td><td className="p-2">{slot.required ? '✓' : '—'}</td><td className="p-2 text-slate-500">{(english ? slot.condition_en : slot.condition_vi) ?? slot.condition ?? slot.ask_if ?? '—'}</td><td className="p-2 text-slate-400"><LockKeyhole size={15} aria-label={t('playbook.locked')} /></td></tr>)}</tbody>
        </table>
      </div>
    </section>
  )
}

